import { useCallback, useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onStoreChange: () => void) => {
    const mql = window.matchMedia(query);
    mql.addEventListener('change', onStoreChange);
    return () => mql.removeEventListener('change', onStoreChange);
  }, [query]);

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}

export const useIsTouchPrimary = () => useMediaQuery('(pointer: coarse)');
